import React from "react";
import { ArrowUpRight, ShieldCheck, Award, Cpu } from "lucide-react";

const WAYNE_IMG =
  "https://customer-assets.emergentagent.com/job_kip-new-landing/artifacts/5w77ba5t_PHOTO-2025-10-10-21-04-26%208.jpg";

const RANGES = [
  {
    name: "Lubrifiants haute performance",
    tag: "Protection & Durabilité",
    desc: "Formulés avec des huiles de base et additifs avancés pour une protection optimale : huiles moteurs, huiles industrielles, fluides techniques et graisses.",
  },
  {
    name: "Carburant",
    tag: "Plateforme globale",
    desc: "Sécurité avancée, plateforme configurable jusqu'à 7 grades de carburant — distributeurs connectés dernière génération.",
  },
  {
    name: "Consommables automobiles",
    tag: "Filtration & Pièces",
    desc: "Filtres (huile, carburant, air, hydrauliques), séparateurs eau/carburant, plaquettes de frein, suspensions, rotules, direction et batteries.",
  },
];

export default function Wayne() {
  return (
    <section
      id="wayne"
      data-testid="wayne-section"
      className="bg-white py-24 sm:py-28"
    >
      <div className="kip-container grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Image */}
        <div className="lg:col-span-5 reveal order-2 lg:order-1">
          <div className="relative">
            <img
              src={WAYNE_IMG}
              alt="Distributeur de carburant Wayne"
              loading="lazy"
              data-testid="wayne-image"
              className="relative w-full h-[520px] object-cover"
            />
            <div className="absolute top-4 left-4 bg-[#E85D26] text-white px-4 py-2 flex items-center gap-2">
              <ShieldCheck size={16} />
              <span className="text-xs font-bold tracking-[0.16em] uppercase">
                USA Tested &amp; Certified
              </span>
            </div>
          </div>
          {/* Trust badges */}
          <div className="grid grid-cols-3 gap-4 mt-6">
            {[
              { icon: Award, label: "150+ ans" },
              { icon: ShieldCheck, label: "Normes ISO" },
              { icon: Cpu, label: "IoT Ready" },
            ].map((b) => (
              <div
                key={b.label}
                className="bg-[#F5F6F8] p-4 text-center border-l-2 border-[#E85D26]"
              >
                <b.icon size={20} className="text-[#E85D26] mx-auto mb-1" />
                <div className="text-xs text-[#1A2744] font-semibold">
                  {b.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Text */}
        <div className="lg:col-span-7 reveal order-1 lg:order-2">
          <span className="kip-overline">Notre Partenaire</span>
          <span className="kip-accent-bar mt-4" />
          <h2 className="font-display font-black text-[#1A2744] text-3xl sm:text-4xl lg:text-[42px] tracking-tight leading-[1.1]">
            Wayne — la référence mondiale et la marque américaine reconnue pour
            ses{" "}
            <span className="text-[#E85D26]">
              produits énergétiques et solutions automobiles performantes.
            </span>
          </h2>
          <p className="mt-6 text-[#334155] text-lg leading-relaxed max-w-2xl">
            Depuis plus de 250 ans, Wayne — marque phare de Dover Fueling
            Solutions — définit les standards de la distribution des produits
            énergétiques et des solutions automobiles performantes dans le
            monde. En tant que distributeur exclusif pour la Côte d'Ivoire, KIP
            Energy vous propose une gamme complète de lubrifiants, filtres,
            batteries et consommables répondant aux standards internationaux. Il
            donne aussi accès à des technologies de pointe dans ses stations :
            distributeurs connectés, systèmes de contrôle de site, énergies
            écologiques et solutions de paiement intégrées.
          </p>

          {/* Ranges */}
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {RANGES.map((r, i) => (
              <div
                key={r.name}
                data-testid={`wayne-range-${i}`}
                className="bg-[#F5F6F8] p-5 border-b-2 border-[#E85D26] hover:bg-white hover:shadow-md transition-all flex flex-col"
              >
                <div className="font-display font-black text-lg lg:text-xl text-[#1A2744] leading-tight">
                  {r.name}
                </div>
                <div className="text-[10px] text-[#E85D26] tracking-[0.2em] uppercase mt-1 font-bold">
                  {r.tag}
                </div>
                <p className="text-sm text-[#334155] mt-3 leading-relaxed">
                  {r.desc}
                </p>
              </div>
            ))}
          </div>

          <a
            href="https://www.wayne.ci"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="wayne-cta"
            className="mt-8 inline-flex items-center gap-2 text-[#E85D26] font-bold uppercase tracking-[0.14em] text-sm hover:gap-3 transition-all"
          >
            Découvrir la gamme Wayne CI
            <ArrowUpRight size={18} />
          </a>
        </div>
      </div>
    </section>
  );
}
